var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDraw = function SvgDraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1682 2.74408L17.5015 6.07741C17.8269 6.40285 17.8269 6.93049 17.5015 7.25592L8.33484 16.4226C8.2185 16.5389 8.07034 16.6182 7.90901 16.6505L3.74234 17.4838C3.15924 17.6004 2.64514 17.0863 2.76176 16.5032L3.5951 12.3366C3.62736 12.1752 3.70666 12.0271 3.82299 11.9107L12.9897 2.74408C13.3151 2.41864 13.8427 2.41864 14.1682 2.74408ZM11.4951 6.595L5.17992 12.9108L4.64121 15.6044L7.33474 15.0657L13.6501 8.75L11.4951 6.595ZM13.5789 4.51184L12.6743 5.41667L14.8285 7.57083L15.7337 6.66667L13.5789 4.51184Z",
    fill: "white"
  }))));
};
export { SvgDraw as ReactComponent };
export default __webpack_public_path__ + "assets/c02b4c40.svg";